// Angular
import {
    Component,
    Input,
    OnInit,
    Output,
    EventEmitter,
    Renderer2,
    OnChanges,
    SimpleChanges,
    ViewChild,
    ChangeDetectionStrategy
} from '@angular/core';

// Services
import { TranslateService } from '@ngx-translate/core';

// Helpers
import moment from 'moment';

// Models
import { DeliveryStatus } from '../../../../shared/models/b2b/deliveryStatus';
import { BrandOption } from '../../../models/b2b/brandOption';
import { toStringByKey } from '../../helpers/utils';
import { Subscriber } from '../../helpers/subscriber';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store';
import { Bill } from '../../../models/b2b/bill';
import { ModalsService } from '../../../../shared/services/utils/modals.service';
import { User } from '../../../../../app/shared/models/b2b/user';
import { Note } from 'app/shared/models/b2b/note';
import { Delivery } from 'app/shared/models/b2b/delivery';

@Component({
    selector: 'app-filter-invoices-orders',
    templateUrl: './filter-invoices-orders.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterInvoicesOrdersComponent extends Subscriber implements OnInit, OnChanges {
    @Input() type: string;
    @Input() user: User;
    @Input() titleSearch: string;
    @Input() prefixSize: string;
    @Input() showConcept: boolean = true;
    @Input() showStatus: boolean = true;
    @Input() bills: Bill[];

    @Input() nameConcept: string = 'Concepto';
    @Input() measures: string = 'Medidas';
    @Input() brand: string = 'Marca';
    @Input() reason: string = 'Motivo';

    @Input() replacementOrderSection: boolean = false;
    @Input() deliveryNotesSection: boolean = false;
    @Input() reasonOptions: any[];
    @Input() statusOptions: DeliveryStatus[];
    @Input() reportStatus: DeliveryStatus[];
    @Input() addressesOptions: any;
    @Input() expirationsSection: boolean = false;
    @Input() reportsSection: boolean = false;

    @Input() searchBrandsOptions: BrandOption[];
    @Input() currentFilter: any = {};
    @Output() filter = new EventEmitter();
    @Output() export = new EventEmitter();
    @Output() filterMobile = new EventEmitter();
    @Output() newIndicenceMobile = new EventEmitter();
    @Input() inModal = false;

    // Opcion 3 => PENDIENTE
    DEFAULT_STATUS_OPTIONS: number = 3;

    applyFilter: any;
    openAdvancedFilter: boolean;
    selectedStatus: DeliveryStatus;
    printReady: boolean = false;
    updatingDatePicker: boolean = false;

    selectedItemsMarcas = [];
    dropdownSettings = {};
    filterBrandNames: string = '';
    textNoData: string;
    textPlaceHolderSearch: string;
    withFilters: boolean = false;
    @Input() orders: Delivery[];
    @Input() deliveries: Note[];

    constructor(
        protected translateService: TranslateService,
        protected renderer: Renderer2,
        protected store: Store<AppState>,
        protected modalsService: ModalsService
    ) {
        super();
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.printReady = true;
        }, 100);

        this.subscribeUserAddresses();

        // Brands
        this.initSelectMultipleMarca();
        this.getTranslates();
    }

    ngOnChanges(changes: SimpleChanges): void {
        const valueOb = changes.currentFilter ? changes.currentFilter.currentValue : {};
        this.currentFilter = this.currentFilter ? this.currentFilter : {};
        this.currentFilter = Object.assign(this.currentFilter, valueOb);
        this.applyFilter = Object.assign({}, this.currentFilter);
        this.applyFilter.brand = this.filterBrandNames ? this.filterBrandNames : this.currentFilter.brand;
        this.user = changes.user ? changes.user.currentValue : null;
        if (changes && changes.searchBrandsOptions && changes.searchBrandsOptions.currentValue) {
            this.searchBrandsOptions = changes.searchBrandsOptions.currentValue;
        }
        if (changes && changes.orders && changes.orders.currentValue) {
            this.orders = changes.orders.currentValue;
        }
        if (changes && changes.deliveries && changes.deliveries.currentValue) {
            this.deliveries = changes.deliveries.currentValue;
        }

        // console.log('onchanges filters: ', valueOb);
        // console.log('currentFilter: ', this.currentFilter);

        // console.log("changes: ", changes);
        if (changes && changes.statusOptions && changes.statusOptions.currentValue) {
            this.currentFilter.status = changes.statusOptions.currentValue[this.DEFAULT_STATUS_OPTIONS].value;
            if (!this.inModal) {
                this.sendFilter();
            }
        }
        if (changes && changes.bills && changes.bills.currentValue) {
            this.bills = changes.bills.currentValue;
        }
    }

    subscribeUserAddresses() {
        this.addSubscription(
            this.store
                .select((state) => state.user.addresses)
                .subscribe((data) => {
                    if (data && data.length) {
                        this.setDefaultFilter();
                    }
                })
        );
    }

    setDefaultFilter(): void {
        switch (this.type) {
            case 'ORDERS':
                this.currentFilter = {
                    date: {
                        from: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                        to: moment().format('YYYY-MM-DD')
                    },
                    status: this.DEFAULT_STATUS_OPTIONS
                };
                break;

            case 'REPORTS':
            case 'REPLACEMENTORDERS':
            case 'EXPIRATIONS':
                if (!this.inModal) this.sendFilter();
                break;
            default:
                this.currentFilter = {
                    date: {
                        from: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                        to: moment().format('YYYY-MM-DD')
                    }
                };
                if (!this.inModal) this.sendFilter();
                break;
        }
    }

    clickToggleAdvancedFilter(): void {
        this.openAdvancedFilter = !this.openAdvancedFilter;
    }

    onEnterForm(ev: any): void {
        if (ev.keyCode === 13) {
            setTimeout(() => {
                this.clickFilter();
            }, 150);
        }
    }

    clickFilter(): void {
        this.openAdvancedFilter = false;
        this.sendFilter();
    }

    clickClearFilters(ev): void {
        ev.preventDefault();

        this.updatingDatePicker = true;
        setTimeout(() => {
            this.updatingDatePicker = false;
        }, 50);

        this.filterBrandNames = '';
        this.currentFilter = {};
        this.applyFilter = undefined;

        this.setDefaultFilter();
        this.initSelectMultipleMarca();

        this.sendFilter();
    }

    onChangeStatus(ev): void {
        if (!this.inModal) {
            setTimeout(() => {
                this.sendFilter();
            }, 50);
        }
    }

    sendFilter(): void {
        this.applyFilter = Object.assign({}, this.currentFilter);
        this.applyFilter.brand = this.filterBrandNames ? this.filterBrandNames : '';
        // console.log('envia: ', { ...this.currentFilter });
        this.filter.emit({ filter: this.currentFilter });
        this.withFilters = this.hasFilters();
        this.modalsService.close('filter-invoices-orders');
    }

    hasFilters(): boolean {
        if (!this.applyFilter) {
            return false;
        } else if (this.applyFilter.search) {
            return true;
        } else if (this.applyFilter.date) {
            return true;
        } else if (this.applyFilter.status && this.applyFilter.status !== -1) {
            return true;
        } else if (this.applyFilter.reportStatus && this.applyFilter.reportStatus !== -1) {
            return true;
        } else if (this.applyFilter.reason) {
            return true;
        } else if (this.showConcept && this.applyFilter.concept) {
            return true;
        } else if (this.applyFilter.search && this.applyFilter.search !== -1) {
            return true;
        } else if (this.applyFilter.brand) {
            return true;
        } else if (this.applyFilter.measures) {
            return true;
        } else {
            return false;
        }
    }

    getStrSearchDate(): string {
        let str: string;

        if (!this.currentFilter.date) {
            return;
        }

        if (this.currentFilter.date.from === this.currentFilter.date.to) {
            str = moment(this.currentFilter.date.from).format('DD/MM/YYYY');
        } else {
            this.translateService
                .get('al')
                .subscribe(
                    (translation) =>
                        (str =
                            moment(this.currentFilter.date.from).format('DD/MM/YYYY') +
                            translation +
                            moment(this.currentFilter.date.to).format('DD/MM/YYYY'))
                );
        }

        return str;
    }

    getStrSearchStatus(): string {
        let str: string;

        if (!this.currentFilter.status) {
            return;
        } else if (this.statusOptions) {
            switch (this.currentFilter.status) {
                case 0:
                    // str = 'CUALQUIERA';
                    str = this.statusOptions['0'].label;
                    break;
                case 1:
                    // str = 'SERVIDO';
                    str = this.statusOptions['1'].label;
                    break;
                case 2:
                    // str = 'S/PARCIAL';
                    str = this.statusOptions['2'].label;
                    break;
                case 3:
                    // str = 'PENDIENTE';
                    str = this.statusOptions['3'].label;
                    break;
                default:
                    // str = 'CUALQUIERA';
                    str = this.statusOptions['0'].label;
                    break;
            }
        }

        return str;
    }

    getStrSearchReportStatus(): string {
        let str: string;

        if (!this.currentFilter.reportStatus) {
            return;
        } else {
            switch (this.currentFilter.reportStatus) {
                case 1:
                    // str = 'ABIERTA';
                    this.addSubscription(
                        this.translateService
                            .get('incidents_table_status_opened')
                            .subscribe((translation) => (str = translation.toUpperCase()))
                    );
                    break;
                case 2:
                    // str = 'CERRADA';
                    this.addSubscription(
                        this.translateService
                            .get('incidents_table_status_closed')
                            .subscribe((translation) => (str = translation.toUpperCase()))
                    );
                    break;
                default:
                    // str = 'CUALQUIERA';
                    this.addSubscription(
                        this.translateService
                            .get('incidents_table_status_any')
                            .subscribe((translation) => (str = translation.toUpperCase()))
                    );
                    break;
            }
        }

        return str;
    }

    clickSpanSelect(idSelect: string, evt): void {
        const selectOb = document.getElementById(idSelect);

        // console.log('click span select: ', selectOb);

        const aux = ViewChild(idSelect, { static: true });
        aux.nativeElement.click();

        selectOb.click();

        setTimeout(function () {
            selectOb.dispatchEvent(evt);
        });
    }

    getTranslates() {
        this.translateService.get(['search_no_data', 'search_placeholder']).subscribe((data) => {
            // console.log('Main Search Translates', data);
            this.textNoData = data.search_no_data;
            this.textPlaceHolderSearch = data.search_placeholder;

            this.updateSelectMultipleMarca();
        });
    }
    initSelectMultipleMarca(): void {
        this.selectedItemsMarcas = [];
        this.updateSelectMultipleMarca();
    }

    updateSelectMultipleMarca(): void {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'label',
            noDataAvailablePlaceholderText: this.textNoData,
            searchPlaceholderText: this.textPlaceHolderSearch,
            itemsShowLimit: 1,
            allowSearchFilter: true,
            enableCheckAll: false
        };
    }

    onChangeSelectMarca($event) {
        const ids: string = toStringByKey('value', this.selectedItemsMarcas);
        const names: string = toStringByKey('label', this.selectedItemsMarcas);

        this.currentFilter.brand = ids;
        this.filterBrandNames = this.applyFilter.brand = names;
    }

    onClickFilterMarca() {
        const input = this.renderer.selectRootElement(
            'app-filter-invoices-orders ng-multiselect-dropdown input[type="text"]'
        );
        setTimeout(() => input.focus(), 0);
    }

    clickExport() {
        this.export.emit();
    }

    openFilterMobile() {
        this.filterMobile.emit();
    }

    clickNewIncidenceMobile() {
        this.newIndicenceMobile.emit();
    }

    removeSpaces(value: string) {
        this.currentFilter.search = value.trim();
    }
}
